module.exports = __webpack_public_path__ + "img/appAsset-bankingLogo__cl_banco_santander_Min.051f0593.svg";